import React from "react"

const defaultState = {}
const Ctx = React.createContext(defaultState)

export default Ctx
